/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { ToastContainer, } from 'react-toastify';
import Pagination from '../../Pagination/pagination';
import { Button } from '@mui/material';
import Spinner from '../../Spinner/spinner';
import { Modal } from 'react-bootstrap';
import UseGroup from '../hooks/useGroup';

const Group = () => {
    const {
        contactDelete,
        statusChange,
        setPage,
        navigate,
        setDeleteShow,
        deleteShow,
        PER_PAGE,
        count,
        page,
        spinner,
        groupsList,
    } = UseGroup()
    return (
        <section>
            {spinner ? <Spinner /> : null}
            <ToastContainer />

            <div className="cus-padd cusheight">
                <button className='btn btn-dark ms-1 float-end mb-2' onClick={() => navigate('add-group')}>Add Group</button>
                <table className="table  shadow mt-3">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Group Name</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !groupsList.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                :
                                <>
                                    {
                                        groupsList?.data?.map((item, index) => {
                                            return <>
                                                <tr>
                                                    <th scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                    <td key={index}>{item.name}</td>
                                                    <td >
                                                        <div className="form-check form-switch" style={{ marginLeft: '44%' }}>
                                                            <input className="form-check-input" role='switch' type="checkbox" checked={item.isActive} onClick={() => statusChange(item)} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                                        </Button>
                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                            <a className="dropdown-item cursor" onClick={() => navigate(`edit-group/${item._id}`)}>Edit</a>
                                                            <a className="dropdown-item cursor" onClick={() => setDeleteShow({ open: true, data: item })}>Delete</a>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </>
                                        })
                                    }
                                </>
                        }
                    </tbody>
                </table>
                <div className='w-100 d-flex justify-content-center mt-5 pb-3'>
                    {count > 10 && <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />}
                </div>
            </div>

            {/* Group Delete Modal */}
            <Modal centered show={deleteShow?.open} size='sm' onHide={() => setDeleteShow({ open: false, data: '' })}>
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <p>Are you sure !</p>
                        <p>You want to delete this group</p>
                        <button type="button" className="btn nobtn" onClick={() => setDeleteShow({ open: false, data: '' })}>
                            No
                        </button>
                        <button type="button" className="btn yesbtn" onClick={() => contactDelete()}>
                            Yes
                        </button>
                    </div>
                </div>
            </Modal>
        </section>
    )
}

export default Group